/** Single-active-audio policy for Canvas Generate Audio nodes. */
let activeCanvasAudio: HTMLAudioElement | null = null

export function pauseOtherCanvasAudio(next: HTMLAudioElement): void {
  if (activeCanvasAudio && activeCanvasAudio !== next && !activeCanvasAudio.paused) {
    activeCanvasAudio.pause()
  }
  activeCanvasAudio = next
}

export function clearCanvasAudioPlayback(el: HTMLAudioElement): void {
  if (activeCanvasAudio === el) activeCanvasAudio = null
}

export function getActiveCanvasAudioForTests(): HTMLAudioElement | null {
  return activeCanvasAudio
}

export function resetCanvasAudioPlaybackCoordinatorForTests(): void {
  activeCanvasAudio = null
}
